(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["leeplus-back-order-notices"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('leeplus-back-order-notices')) {
    class LeeplusBackOrderNotices extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.content = this.querySelector('.leeplus-bo-content');
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (button?.hasAttribute('data-bo-close')) this.dialog.close();
          if (button?.hasAttribute('data-bo-proceed')) {
            const checkout = this.checkout;
            this.checkout = null;
            this.dialog.close();
            if (checkout?.isConnected && !checkout.disabled) {
              this.bypass = true;
              try { checkout.click(); } finally { this.bypass = false; }
            }
          }
        }, options);
        this.dialog.addEventListener('close', () => { this.checkout = null; }, options);
        document.addEventListener('click', (event) => {
          const checkout = event.target.closest?.('button[name="checkout"], input[name="checkout"]');
          if (!checkout || checkout.disabled || this.bypass) return;
          this.intercept(event, checkout);
        }, { ...options, capture: true });
        document.addEventListener('submit', (event) => {
          if (this.bypass || event.submitter?.name !== 'checkout') return;
          this.intercept(event, event.submitter);
        }, { ...options, capture: true });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.showProduct();
        }, options);
        this.showProduct();
      }
      disconnectedCallback() { this.controller?.abort(); }
      showProduct() {
        const template = this.querySelector('[data-bo-product]');
        if (template && !this.dialog.open) this.open(template);
      }
      open(template) {
        this.content.replaceChildren(template.content.cloneNode(true));
        if (!this.dialog.open) this.dialog.showModal();
      }
      intercept(event, checkout) {
        if (checkout.dataset.boRequired !== 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.dialog.open && this.checkout) return;
        this.checkout = checkout;
        this.open(this.querySelector('[data-bo-checkout]'));
        const date = checkout.dataset.boEtd || '';
        this.content.querySelector('[data-bo-date]').hidden = !date;
        this.content.querySelector('[data-bo-date] span').textContent = date;
        this.content.querySelector('[data-bo-missing]').hidden = checkout.dataset.boMissing !== 'true';
      }
    }
    customElements.define('leeplus-back-order-notices', LeeplusBackOrderNotices);
  }
  } catch(e) { console.error(e); }
})();

})();
